// THE HEADER SEARCH ENDS HERE — the writes a close of the open search makes
// (AppHeader › HeaderSearch: the morph shown while root `_headerSearchOpen` is
// true). N2 (Nika 2026-10-27, "fix navbar search button click on workspace for
// both left and top navbar modes"): two closes the header promised never
// existed, and both land here:
//   - a press outside the open search (AppHeader › HeaderSearch
//     `onDocumentMousedown`) passes `returnFocusTo: null` — focus follows the
//     press and is never pulled back to the button;
//   - a second press of the search button (HeaderTabs › SearchBtn) passes its
//     own node — the morph's close edge (AppHeader focusSearchOnOpen) hands
//     focus back to it.
// Without `returnFocusTo` the target the opener stored stays. The results and
// the launcher end through the shell's `closeNavSearch` (the workspace's
// functions/search/globalSearch.js), reached through `this.call` and
// availability-checked: a host without it closes the morph alone. The two
// state writes are the Close X's own.
// el.call('closeHeaderSearch', { returnFocusTo }) → whether it closed.
export function closeHeaderSearch(opts) {
  const el = this
  const root = el && el.state && el.state.root
  if (!root || !root._headerSearchOpen || typeof root.update !== 'function') return false
  if (opts && typeof opts === 'object' && 'returnFocusTo' in opts) {
    root.__headerSearchReturnFocusTo = opts.returnFocusTo || null
  }
  if (typeof el?.context?.functions?.closeNavSearch === 'function') {
    try {
      el.call('closeNavSearch')
    } catch (err) {
      console.warn('[closeHeaderSearch] closeNavSearch failed:', err)
    }
  }
  root.update({ _headerSearchOpen: false, _navSearchOpen: false })
  return true
}
